import React from 'react';
import { useLocation } from 'react-router-dom';
import { isDomainMode } from '../../utils/domainMode';
import { isCustomerSurface, shopSlugOfPath } from '../../utils/shopSurface';
import { useCurrentProductName, useCurrentShop } from '../../utils/currentShop';
import { useOptionalCart } from '../../Context/CartContext';
import AgentChat from './AgentChat';

/**
 * THE CUSTOMER AGENT ON EVERY PAGE OF THE SHOP (customer agent, 10-21).
 *
 * Mounted once in App.js beside the floating dock, by the dock's own rules: the shop the pages remembered
 * (utils/currentShop), any page of THIS business the shopper browses (utils/shopSurface — never a checkout, a placed
 * order or a booking confirmation), under this shop's slug on stylon.online. And only where the business switched the
 * new agent on (`customerAgentV2`); everywhere else the old home-page widget stays.
 */
export default function ShopAgentChat() {
  const { pathname } = useLocation();
  const salon = useCurrentShop();
  const productName = useCurrentProductName();
  const slug = salon?.slug || salon?.username;
  const cart = useOptionalCart(slug || '__none__');
  if (!salon || salon.customerAgentV2 !== true || !slug) return null;
  const domainMode = isDomainMode();
  if (!isCustomerSurface(pathname, domainMode)) return null;
  if (!domainMode && shopSlugOfPath(pathname) !== slug) return null;
  const cartLines = (cart.items || []).map((i) => ({ productId: i.productId, variantId: i.variantId, quantity: i.quantity, name: i.snapshot?.name }));
  // The cart itself too: the chat's selection shows its lines and changes them through the cart's own writers.
  return <AgentChat salon={salon} cartLines={cartLines} cart={cart} productName={productName} domainMode={domainMode} />;
}
